import axios from "axios";

import { TeamListModel, TeamCreateModel, TeamDetailModel, TeamEditModel } from "./model";

const apiUrl = "/api/team";

const getAll = async (): Promise<TeamListModel[]> => {
    const response = await axios.get<TeamListModel[]>(apiUrl);
    return response.data;
};

const get = async (id: string): Promise<TeamDetailModel> => {
    const response = await axios.get(`${apiUrl}/${id}`);
    return response.data;
};

const create = async (team: TeamCreateModel): Promise<TeamListModel> => {
    const response = await axios.post(apiUrl, team);
    return response.data;
};

const save = async (team: TeamEditModel): Promise<TeamDetailModel> => {
    const response = await axios.put(`${apiUrl}/${team.id}`, team);
    return response.data;
};

const deleteTeam = async (id: string): Promise<void> => {
    await axios.delete(`${apiUrl}/${id}`);
};

export const TeamApi = { getAll, get, create, save, delete: deleteTeam };
